const DEFAULT_OPTIONS = {
    iconSizePx: 24,
    locale: 'en',
    themeOption: 'light'
};
export { DEFAULT_OPTIONS };
